// =========================================
// Accredited Logos
// Draggable logo slider on mobile/tablet; static centred row on desktop.
// Swiper comes from the shared swiper-core bundle (window.Swiper).
// Figma 329:8677 (mobile slider) / 329:6503 (desktop row)
// =========================================
document.addEventListener('DOMContentLoaded', function () {
    const Swiper = window.Swiper;
    const { FreeMode } = window.SwiperModules || {};
    if (!Swiper) return;

    const sliders = document.querySelectorAll('[data-accredited-logos]');
    if (!sliders.length) return;

    sliders.forEach(function (el) {
        new Swiper(el, {
            modules: FreeMode ? [FreeMode] : [],
            slidesPerView: 'auto',
            spaceBetween: 24,
            freeMode: true,
            grabCursor: true,
            watchOverflow: true,            // lock when all slides fit
            centerInsufficientSlides: true, // centre when they don't fill the track
            breakpoints: {
                // Desktop (lg+) — disable the slider; CSS lays the logos out as a row.
                992: { enabled: false },
            },
        });
    });
});
